// LIVE
// export const BASEURL = "https://api.aliff.in/api";
// export const FILESURL = "https://api.aliff.in";
// export const FRONTEND_BASEURL = "https://aliff.in/";
// export const DASHBOARD_BASEURL = "https://app.aliff.in/";
// export const LMS_URL = "https://api-lms.aliff.in/api";


// STG
// export const BASEURL = "https://api-alif.binarynumbers.io/api";
// export const FILESURL = "https://api-alif.binarynumbers.io";
// export const FRONTEND_BASEURL = "https://alif-website.binarynumbers.io/";
// export const DASHBOARD_BASEURL = "https://student-dashboard-alif.binarynumbers.io/";
// export const LMS_URL = "https://api-lms.aliff.in/api";

// Switz
export const BASEURL = "https://api.switzeducation.com/api";
export const FILESURL = "https://api.switzeducation.com";
export const FRONTEND_BASEURL = "https://switzeducation.com/";
export const DASHBOARD_BASEURL = "https://app.switzeducation.com/";

// DEV
// export const BASEURL = "http://localhost:8002/api";
// export const FILESURL = "http://localhost:8002";
// export const FRONTEND_BASEURL = "http://localhost:8081/";
// export const DASHBOARD_BASEURL = "http://localhost:8081/";
// export const LMS_URL = "http://localhost:9003/api";


export const API_VERSION = "v1.0";
export const S3BASEURL = "";



// WEBPACK FOOTER //
// ./src/config/index.js